import { SortDirection } from '@angular/material/sort';
import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { PAGE_SIZE_DEFAULT } from '../../_common/constants';
import { PrinterMechanismStatusResponse, PrintersStatusListResponse, PrintersStatusModel } from './printers-status.model';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})

export class PrintersStatusService {
  constructor(private http: HttpClient,
    @Inject('API_URL') private apiUrl: string
  ) { }
  
  private downloadPrintersStatusSubject = new Subject<any>();
  private canDownloadPrintersStatusSubject = new BehaviorSubject<boolean>(false);

  downloadPrintersStatus$ = this.downloadPrintersStatusSubject.asObservable();

  get canDownload(): boolean {
    return this.canDownloadPrintersStatusSubject.value;
  }

  set canDownload(value: boolean) {
    this.canDownloadPrintersStatusSubject.next(value);
  }

  download(type: string) {
    this.downloadPrintersStatusSubject.next(type);
  }
  
  getPrintersStatuses(pageIndex: number = 0, pageSize: number = PAGE_SIZE_DEFAULT, sortBy: string, sortDir: SortDirection, filter: any): Observable<PrintersStatusListResponse> {
    return this.http
      .get<PrintersStatusListResponse>(
        this.apiUrl + 'PrinterStatus/printer-status',
        {
          params: new HttpParams()
            .set('sortBy', sortBy)
            .set('sortDir', sortDir)
            .set('pageNumber', pageIndex.toString())
            .set('pageSize', pageSize.toString())
            .set('filter', JSON.stringify(filter))
        }
      );
  }

  checkPrinterMachanismStatus(printerIp: string): Observable<PrinterMechanismStatusResponse> {
    return this.http
      .get<PrinterMechanismStatusResponse>(
        this.apiUrl + 'PrinterStatus/check-printer-mechanism-status',
        {
          params: new HttpParams()
            .set('printerIp', printerIp)
        }
      );
  }

  downloadXlsx(filters: any) {
    return this.http.get(this.apiUrl + 'PrinterStatus/download-xlsx', {
      params: new HttpParams().set('filter', JSON.stringify(filters)),
      observe: 'response',
      responseType: 'blob',
    }).pipe(
      map((response) => {
        const contentDisposition = response.headers.get('Content-Disposition');
        let filename = this.getFileName(contentDisposition, 'xlsx');
        return { body: response.body as Blob, filename, status: response.status };
      })
    );
  }


  private getFileName(contentDisposition: string, type: string) {
    let filename = 'PrintersStatus.' + type;
    if (contentDisposition) {
      const filenameStarMatch = /filename\*\s*=\s*UTF-8''([^;]+)/i.exec(contentDisposition);

      const filenameMatch = /filename\s*=\s*"?([^;"]+)"?/i.exec(contentDisposition);

      if (filenameStarMatch && filenameStarMatch[1]) {
        filename = decodeURIComponent(filenameStarMatch[1]);
      } else if (filenameMatch && filenameMatch[1]) {
        filename = filenameMatch[1];
      }
    }
    return filename;
  }
}
